<template>
  <div>
    <div class="qiye">
      <ul>
        <li class="qiye_list" v-for="(item,index) in subjects" :key="index">
          <router-link :to="{path:'/biaodiDetails',query:{ id:item.id }}" class="qiye_list_router">
            <div style="position: relative;" class="qiye_img" :style="{'backgroundImage':'url('+item.img+')'}">
              <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
            </div>
            <div class="qiye_right">
              <h3>{{ item.title }}</h3>
              <div class="qiye_js">
                <p>标的介绍</p>
                <p class="qiye_content" v-html="item.summary"></p>
              </div>
              <div class="qiye_bottom">起拍价格：{{ item.start_price }}</div>
              <div class="qiye_bottom">拍卖时间：{{ item.start_at }}</div>
              <div class="qiye_bottom">公示时间：{{ item.created_at|formatDate }}</div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="fenye">
      <ul>
        <li class="fenyehidden"><a v-on:click="setPage(paginator.first)">{{$t("subject.pagination.first")}}</a></li>
        <li v-if="paginator.current > 1"><a v-on:click="setPage(paginator.before)">{{$t("subject.pagination.prev")}}</a></li>
        <li v-if="paginator.current == 1" class="banclick fenyehidden"><a>{{$t("subject.pagination.prev")}}</a></li>
        <!--当前页背景色为蓝色-->
        <li v-for="index in indexs" v-bind:class="{ 'active': paginator.current == index}" :key="index">
          <a v-on:click="setPage(index)">{{ index }}</a>
        </li>
        <li v-if="paginator.current < paginator.total_items"><a v-on:click="setPage(paginator.next)">{{$t("subject.pagination.next")}}</a></li>
        <li v-if="paginator.current == paginator.total_items" class="banclick"><a>{{$t("subject.pagination.next")}}</a></li>
        <li class="fenyehidden"><a v-on:click="setPage(paginator.last)">{{$t("subject.pagination.last")}}</a></li>
        <li class="fenyehidden"><a>{{$t("subject.pagination.all")}} {{ paginator.total_pages }} {{$t("subject.pagination.pages")}} {{ paginator.total_items }} {{$t("subject.pagination.record")}}</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/assets/js/date.js'
import { decryptAES } from '@/utils/crypto';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
    }
  },
  filters: {
    formatDate (time) {
      // let date = new Date(time)
      // return formatDate(date, 'yyyy-MM-dd')
      if (time !== null) {
        let temp = time.split(' ');
        return temp[0];
      }
      return '';
    }
  },
  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)

    // 加载路由参数
    this.getRouteQuery()
    // 请求列表数据
    this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  // 方法属性
  methods: {
    // 获取路由参数
    getRouteQuery: function () {
      if (this.$route.query.page !== undefined) {
        this.paginator.current = this.$route.query.page;
      }
    },

    getSubjects: function () {
      // 请求页面数据
      var order = "id DESC";
      this.axios.get(this.$global.apiUrl.subjects, {
        params: {
          page: this.paginator.current,
          limit: this.paginator.limit,
          order: order,
          status: 5
        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            let subjects = response.data.subjects;
            // 解密每个标的的敏感字段
            if (subjects && subjects.length) {
              subjects.forEach(item => {
                if (item.summary) item.summary = decryptAES(item.summary);

              });
            }
            this.subjects = response.data.subjects;
            this.paginator = response.data.paginator;
          }
        })
        .catch(() => {
          // console.log(response.data.error.message)
        })
    },

    setPage: function (page) {
      let query = Object.assign({}, this.$route.query, { page: page })
      this.$router.push({ query: query })
    },

    resetPage: function (query) {
      return Object.assign({}, query, { page: 1 })
    },
  },
  // 监听器
  watch: {
    $route () {
      this.paginator.current = this.$route.query.page;
      this.getSubjects();
    },
  },
  // 计算属性
  computed: {
    // 分页
    indexs: function () {
      var left = 1;
      var right = this.paginator.total_pages;
      var ar = [];
      if (this.paginator.total_pages >= 5) {
        //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
        if (this.paginator.current > 3 && this.paginator.current < this.paginator.total_pages - 1) {
          //以4为参考基准，左面加2右边加2
          left = this.paginator.current - 2
          right = this.paginator.current + 2
        } else {
          if (this.paginator.current <= 3) {
            left = 1
            right = 5
          } else {
            right = this.paginator.total_pages
            left = this.paginator.total_pages - 4
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  }
}
</script>